import { styled } from '@slal/ui';
import { Input } from '@slal/ui/forms';
import { breakpointUp } from '@slal/ui/helpers';
import { ErrorIcon } from '@slal/ui/icons';
import {
    Field as SUIField,
    CardRadioFieldGroup as SUIRadioFieldGroup,
    TextField as SUITextField,
} from '@slal/ui/react-hook-form/fields';
import { Article } from '@slal/ui/typography';
import { Text } from '../Typography';

export const relatedFieldIndent = '44px';

export const Field = styled(SUIField)`
    margin-bottom: 0;
`;

export const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 32px;
`;

export const StyledFieldSet = styled.fieldset`
    margin: 0 0 ${({ theme }) => theme.space[7]};
    padding: 0;
    border: 0;
`;

export const ErrorWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.space[3]};
`;

export const FieldErrorMessage = styled(Text)`
    margin-top: ${({ theme }) => theme.space[2]};
    color: ${({ theme }) => theme.colors.danger};
    font-size: ${({ theme }) => theme.fontSizes[3]};
`;

export const StyledErrorIcon = styled(ErrorIcon)`
    color: ${({ theme }) => theme.colors.danger};
    margin-right: ${({ theme }) => theme.space[3]};
`;

export const StyledSubmitButtonWrapper = styled.div`
    display: flex;
    margin-top: ${({ theme }) => theme.space[7]};
    padding-bottom: ${({ theme }) => theme.space[7]};
`;

export const StyledFieldHelp = styled(Text)`
    display: block;
    margin-top: ${({ theme }) => theme.space[4]};
    font-size: ${({ theme }) => theme.fontSizes[3]};
    font-family: ${({ theme }) => theme.fonts.sansSerif.family};
    font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
    color: ${({ theme }) => theme.colors.neutral__light__70}!important;
`;

export const StyledFormIntroduction = styled(Article)`
    margin-bottom: ${({ theme }) => theme.space[5]};
    p {
        margin-top: -${({ theme }) => theme.space[5]};
    }
`;

const getSize = (size?: number) => {
    if (!size) return '100%';
    switch (size) {
        case 4:
            return '84px';
        case 3:
            return '68px';
        case 2:
            return '62px';
        default:
            return '44px';
    }
};

export const StyledInput = styled(Input)`
    width: ${({ size }) => getSize(size)};
    margin-right: ${({ size, theme }) => (size ? theme.space[4] : '0')};
`;

export const StyledDateFieldSet = styled(StyledFieldSet)`
    padding-top: ${({ theme }) => theme.space[2]};
    margin: 0;
    label {
        margin-bottom: ${({ theme }) => theme.space[4]};
        font-size: inherit;
        font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
    }
`;

export const TextField = styled(SUITextField)`
    font-size: 16px;
    width: ${({ size }) => getSize(size)};
`;

export const CurrencyInput = styled(Input)`
    font-size: 16px;
    width: 100%;
    ${breakpointUp.md`
        width: 200px;
    `}
`;
export const RadioFieldGroup = styled(SUIRadioFieldGroup)`
    display: inline-flex;
    width: 100%;
    margin: 0;
    padding: 0;
    border: none;
    align-items: ${({ stacked }) => (stacked ? 'flex-start' : 'middle')};
    flex-wrap: wrap;
    gap: 8px;
    flex-direction: ${({ stacked }) => (stacked ? 'column' : 'row')};
    > label {
        width: 100%;

        > div {
            flex-direction: row-reverse;
            min-width: 100%;
            margin-right: 0;
            border-radius: 8px;
            padding: 16px;
            border: 1px solid #8f939c;
            background: #fff;
            margin-bottom: 0;
            &:has(input:checked) {
                border-color: ${({ theme }) => theme.colors.blue__secondary__70};
            }
            ${breakpointUp.md`
            min-width: 400px;
        `}
        }
    }
`;
